import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable, signal } from '@angular/core';
import { environment } from '@env/environment';
import { AccountType, IAccount, IListResponse, ILoadFundsForm } from '@lib/interfaces';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AccountsService {
    environment_url: string;
    reloadAccountsList: EventEmitter<boolean> = new EventEmitter();
    reloadWalletList: EventEmitter<boolean> = new EventEmitter();
    agentsAccounts = signal(new Map<string, string>()); // this will contain agent's account list in (currency, account_id) format

    constructor(private http: HttpClient) {
        this.environment_url = environment.api_url;
    }

    getAccountsByUserId(userId: string, type?: AccountType): Observable<IListResponse<IAccount>> {
        return this.http.get<IListResponse<IAccount>>(`${this.environment_url}nfront/v1/proxy/accounts?user_id=${userId}${type ? `&type=${type}` : ''}&limit=50`);
    }

    fetchAccountDetails(accountId: string): Observable<any> {
        return this.http.get<any>(`${this.environment_url}nfront/v1/proxy/accounts/${accountId}`);
    }
    accountDetails(card_product_id: string | null): Observable<any> {
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/accounts`, {
            user_id: localStorage.getItem('userId'),
            type: 'PREPAID',
            card_product_id,
        });
    }

    loadFunds(payload: ILoadFundsForm, accountId: string, loadFunds = 'loadFunds'): Observable<any> {
        const headers = new HttpHeaders({
                    'x-nymos-idempotency-key': crypto.randomUUID(),
                });
        return this.http.post<any>(`${this.environment_url}nfront/v1/proxy/accounts/${accountId}:${loadFunds}`, payload, { headers });
    }
}
